(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nextyou-motion-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const smallScreen = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initialize(root) {
      if (instances.has(root)) return;

      const video = root.querySelector('.ny-motion-hero__video');
      if (!video) return;

      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      let inView = true;
      let revealReady = false;
      let timer = null;
      let observer = null;
      let disposed = false;

      // Native <source media="…"> wählt die MP4. Javascript muss keine src einsetzen.
      const playbackAllowed = () => {
        const mobile = smallScreen.matches;
        const allowed = mobile
          ? root.dataset.mobileAutoplay === 'true'
          : root.dataset.desktopAutoplay === 'true';
        if (!allowed || reducedMotion.matches) return false;
        if (root.dataset.respectDataSaver === 'true' && connection && connection.saveData) return false;
        return mobile
          ? !!video.querySelector('source[media^="(max-width"]')
          : !!video.querySelector('source[media^="(min-width"]');
      };

      const updateVisibility = () => {
        if (disposed) return;
        const isPlaying = revealReady && playbackAllowed() && inView && !document.hidden &&
          !video.paused && video.readyState >= 2;
        root.classList.toggle('ny-motion-hero--playing', isPlaying);
      };

      const sync = () => {
        if (disposed) return;
        if (!playbackAllowed() || !inView || document.hidden) {
          video.pause();
          root.classList.remove('ny-motion-hero--playing');
          return;
        }
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => root.classList.remove('ny-motion-hero--playing'));
        }
        updateVisibility();
      };

      const onMediaChange = () => {
        root.classList.remove('ny-motion-hero--playing');
        video.pause();
        // Bei Wechsel zwischen Desktop und Mobile Quelle neu auswählen.
        video.load();
        sync();
      };

      const onLoad = () => {
        const delay = Math.max(0, Number(root.dataset.videoDelay) || 0);
        timer = window.setTimeout(() => {
          revealReady = true;
          sync();
        }, delay);
      };

      video.addEventListener('playing', updateVisibility);
      video.addEventListener('pause', updateVisibility);
      video.addEventListener('emptied', updateVisibility);
      video.addEventListener('error', updateVisibility);
      smallScreen.addEventListener('change', onMediaChange);
      reducedMotion.addEventListener('change', onMediaChange);
      document.addEventListener('visibilitychange', sync);

      if ('IntersectionObserver' in window) {
        inView = false;
        observer = new IntersectionObserver(entries => {
          inView = entries.some(entry => entry.isIntersecting);
          sync();
        }, { rootMargin: '100px 0px' });
        observer.observe(root);
      }

      root.classList.add('ny-motion-hero--js');
      if (document.readyState === 'complete') onLoad();
      else window.addEventListener('load', onLoad, { once: true });
      sync();

      instances.set(root, () => {
        disposed = true;
        window.clearTimeout(timer);
        window.removeEventListener('load', onLoad);
        smallScreen.removeEventListener('change', onMediaChange);
        reducedMotion.removeEventListener('change', onMediaChange);
        document.removeEventListener('visibilitychange', sync);
        video.removeEventListener('playing', updateVisibility);
        video.removeEventListener('pause', updateVisibility);
        video.removeEventListener('emptied', updateVisibility);
        video.removeEventListener('error', updateVisibility);
        if (observer) observer.disconnect();
        video.pause();
      });
    }

    const scan = container => {
      if (container.matches && container.matches('[data-ny-motion-hero]')) initialize(container);
      container.querySelectorAll('[data-ny-motion-hero]').forEach(initialize);
    };

    scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      const roots = event.target.querySelectorAll('[data-ny-motion-hero]');
      roots.forEach(root => {
        const destroy = instances.get(root);
        if (destroy) destroy();
        instances.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
